<div class="casino-seo-margin casino-lobby-width" *ngIf="seoboxes">
    <mc-seoboxes class="mc-seoboxes" [seoboxes]="seoboxes"> </mc-seoboxes>
</div>
